import ProviderInfo from "@/model/provider/ProviderInfo"
import DynamicProviderKey from "@/model/provider/DynamicProviderKey"
import OfferTypeIds from "@/model/provider/OfferTypeIds";
import HFDLoanType from "@/model/provider/HFDLoanType"
import ProductType from "@/model/apply/ProductType";

const Providers = {
    synchrony_standard: new ProviderInfo({
        providerId: "synchrony",
        name: "Synchrony",
        financingName: "Care Credit Credit Card",
        fetchPaymentPlansOnResume: true,
        paymentCalculatorRecalculatingModal: true,
        logo: "asset://clearchoice/provider/logos/carecredit.png",
        paymentPlanFilterOverrides: [
            {
                filterKey: "credit-card",
                types: [
                    OfferTypeIds.DEFERRED_INTEREST,
                    OfferTypeIds.FIXED_RATE
                ]
            }
        ],
        productType: ProductType.CREDIT
    }),
    lendingclub_standard: new ProviderInfo({
        providerId: "lendingclub",
        name: "LendingClub",
        financingName: "LendingClub Patient Solutions",
        fetchPaymentPlansOnResume: true,
        paymentCalculatorRecalculatingModal: true,
        acceptOfferOnSelectOffer: true,
        patchOnContinue: false,
        logo: "asset://clearchoice/provider/logos/lendingclub.png",
        altLogo: "asset://clearchoice/provider/logos/lendingclub-without-words.png",
        productType: ProductType.LOAN
    }),
    proceed_standard: new ProviderInfo({
        providerId: "proceed",
        name: "Proceed Finance",
        financingName: "Proceed Finance",
        fetchPaymentPlansOnResume: true,
        paymentCalculatorRecalculatingModal: true,
        publishContinueUrl: true,
        patchOnContinue: true,
        logo: "asset://clearchoice/provider/logos/proceed.png",
        subLender:
            {
                id: "onemain",
                name: "OneMain Financial",
                financingName: "WebBank serviced by OneMain Financial",
                logo: "asset://clearchoice/provider/logos/onemain.svg",
                footerText: "Dental loans are made by WebBank and serviced by OneMain Financial Group, LLC (NMLS #1339418)."
            },
        productType: ProductType.LOAN
    }),
    hfd_standard: new ProviderInfo({
        providerId: "hfd",
        name: "HFD Finance",
        financingName: "HFD Finance",
        fetchPaymentPlansOnResume: true,
        paymentCalculatorRecalculatingModal: true,
        minOffersWithPrequalifiedAmount: true,
        selectOfferWithPrequalifiedAmount: true,
        logo: "asset://clearchoice/provider/logos/hfd.png",
        footerLogo: {
            [HFDLoanType.BANKLOAN]: "asset://clearchoice/provider/logos/hatchbank.png"
        },
        productType: ProductType.LOAN,

    })
}

Object.keys(Providers).forEach(
    providerKey => (Providers[DynamicProviderKey.extractProviderKey(providerKey)].providerKey = providerKey)
)

export default Providers
